<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="d-flex flex-column">
                <div class="text-right mb-3"></div>
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                            size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields"
                        :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light"
                        class="sa-b-table">
                        <template #cell(index)="row">
                            <span> {{ (currentPage - 1) * perPage + row.index + 1 }} </span>
                        </template>
                        <template #cell(nome)="row">
                            <span class="font-weight-bold">{{ row.item.nome }}</span>
                        </template>
                        <template #cell(updateDate)="row">
                            <span>{{ formatDataOra(row.item.updateDate) }}</span>
                        </template>
                        <template v-slot:cell(actions)="row">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Modifica" variant="outline-success"
                                    @click="onClickEditGruppo(row.item)">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover title="Cancella" variant="outline-danger"
                                    @click="onClickDeleteGruppo(row.item)" class="mr-1 no-text">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                            size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import UtilityMixin from "../../../utility/UtilityMixin.js";
export default {
    mixins: [UtilityMixin],
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/accettazionessngruppi",
            showModalLoading: false,
            listKey: 0,
            filtro: {},
            items: [],
            fields: [
                { label: "*", key: "index", thStyle: "width: 1rem" },
                { label: "Nome", key: "nome", thStyle: "width: 10rem", sortable: true },
                { label: "Descrizione", key: "descrizione", thStyle: "width: 15rem", sortable: true },
                { label: "Note", key: "note" },
                { label: "Proprietario", key: "proprietario", thStyle: "width: 8rem" },
                { label: "Ultima Modifica", key: "updateDate", thStyle: "width: 9rem" },
                { label: "Utente", key: "updateUser", thStyle: "width: 8rem" },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    watch: {
        currentPage() {
            this.loadData();
        },
    },
    methods: {
        loadData() {
            let me = this;
            me.openShowModalLoading();
            if (sessionStorage["filtroAccettazioneSsnGruppi"]) {
                me.filtro = JSON.parse(sessionStorage["filtroAccettazioneSsnGruppi"]);
            }
            me.filtro.page = me.currentPage;
            me.filtro.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtro, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.closeShowModalLoading();
            me.$emit("afterLoadData", me.items);
        },
        loadDataError(error) {
            let me = this;
            console.error("Errore durante il caricamento dei gruppi:", error);
            me.items = [];
            me.rows = 0;
            me.closeShowModalLoading();
            me.$emit("afterLoadData", me.items);
        },
        formatDataOra(value) {
            return value ? moment(value).format("DD/MM/YYYY HH:mm") : "";
        },
        onClickEditGruppo(item) {
            this.$emit("editGruppo", item);
        },
        onClickDeleteGruppo(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di voler eliminare il gruppo \"" + item.nome + "\"?", {
                    title: "Eliminazione Gruppo",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteGruppo(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteGruppo(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, null, me.deleteGruppoSuccess, me.deleteGruppoError);
        },
        deleteGruppoSuccess() {
            let me = this;
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.loadData();
        },
        deleteGruppoError() {
            this.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>

<style scoped>
.sa-badge-action {
    text-align: end !important;
}
</style>
